import React, { useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import "./style.scss";

import bag_decor_img from "assets/imgs/CTKMJ2K/CTKM_bagdecor.png";
import vnpt_logo from "assets/imgs/CTKMJ2K/CTKMJ2K_VNPT_Logo.png";
import lazada from "assets/imgs/CTKMJ2K/SieuVoucherMyVNPT_1200x600px.png";
import stepGetVoucher1 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14.png";
import stepGetVoucher2 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14-6.png";
import stepGetVoucher3 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14-7.png";
import stepGetVoucher4 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14-8.png";
import stepGetVoucher5 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14-9.png";
import stepGetVoucher6 from "assets/imgs/CTKMJ2K/getvoucher/iPhone14-10.png";

import stepUseVoucher1 from "assets/imgs/CTKMJ2K/usevoucher/iPhone14-1.png";
import stepUseVoucher2 from "assets/imgs/CTKMJ2K/usevoucher/iPhone14-2.png";
import stepUseVoucher3 from "assets/imgs/CTKMJ2K/usevoucher/iPhone14-3.png";
import stepUseVoucher4 from "assets/imgs/CTKMJ2K/usevoucher/iPhone14-4.png";
import stepUseVoucher5 from "assets/imgs/CTKMJ2K/usevoucher/iPhone14-5.png";

const CTKMj2k = () => {
  let refCarousel = useRef(null);
  const [showGetVoucher, setShowGetVoucher] = useState(true);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const getVoucher = {
    image: [
      stepGetVoucher1,
      stepGetVoucher2,
      stepGetVoucher3,
      stepGetVoucher4,
      stepGetVoucher5,
      stepGetVoucher6,
    ],
    title: [
      "Bước 1: Kiểm tra liên kết tài khoản VNPT Money",
      "Bước 2: Thêm liên kết",
      "Bước 3: Chọn giao dịch thanh toán để nhận voucher 50%",
      "Bước 4: Thực hiện giao dịch",
      "Bước 5: Thực hiện thanh toán",
      "Bước 6: Hoàn tất thanh toán",
    ],
    content: [
      `Mở app MyVNPT chọn "Cá nhân".<br/> Tại mục <span class="semi-bold">Quản lý thanh toán</span> nếu:<br/>- Đã có nguồn tiền VNPT Pay hoặc Mobile money<br/> (hoặc cả 2) thì thực hiện tiếp <span class="semi-bold">Bước 3</span><br/>- Nếu chưa có nguồn tiền nào thì bấm chọn Thêm liên kết và thực hiện tiếp <span class="semi-bold">Bước 2</span>`,
      `Chọn Bắt đầu ngay và thực hiện các bước liên kết tài khoản VNPT money với MyVNPT theo hướng dẫn trên app. Nếu chưa có tài khoản VNPT Money, vui lòng xem hướng dẫn tạo tài khoản <a href="https://my.vnpt.com.vn/tinh-nang/tin-tuc?tab=0&id=4923">tại đây</a>`,
      `Chọn 1 trong các loại dịch vụ thanh toán dưới đây để nhận voucher 50%:<br/>- Nạp điện thoại VinaPhone<br/>- Mua mã thẻ Vinaphone<br/>- Đóng cước viễn thông<br/>- Thanh toán đơn hàng<br/>- Đóng trước cước`,
      `Đối với dịch vụ <span class="semi-bold">Nạp điện thoại</span>, nhập số điện thoại VinaPhone cần nạp, chọn mệnh và ấn <span class="semi-bold">Nạp ngay</span><br/>(Thao tác tương tự với các dịch vụ khác khi lựa chọn trên app)`,
      `Chọn <span class="semi-bold">nguồn tiền</span> thanh toán: Ví VNPT Pay hoặc Mobile money hoặc NH nội địa / quốc tế khác`,
      `Thực hiện thanh toán theo nguồn tiền đã chọn và chờ nhận voucher 50 % giá trị thanh toán(tối đa 50.000đ) trong vòng 48h`,
    ],
  };

  const useVoucher = {
    image: [
      stepUseVoucher1,
      stepUseVoucher2,
      stepUseVoucher3,
      stepUseVoucher4,
      stepUseVoucher5,
    ],
    title: [
      "Bước 1: Truy cập dịch vụ Nạp điện thoại",
      "Bước 2: Lựa chọn mệnh giá",
      "Bước 3: Chọn nguồn tiền thanh toán",
      "Bước 4: Sử dụng voucher",
      "Bước 5: Hoàn tất giao dịch sử dụng voucher",
    ],
    content: [
      `<span class="semi-bold">* Để xem thông tin voucher ưu đãi</span> Vui lòng Mở app MyVNPT chọn <span class="semi-bold">Xem tất cả</span> tại mục "<span class="semi-bold">Dịch vụ ưa thích</span>", chọn icon <span class="semi-bold">Voucher ưu đãi</span> trong mục "<span class="semi-bold">Tiện ích mở rộng</span>" và xem thông tin voucher tại tab "<span class="semi-bold">Quà tặng của tôi</span"`,
      `Nhập số điện thoại VinaPhone cần nạp, chọn mệnh và ấn Nạp ngay`,
      `Chọn nguồn tiền thanh toán là Ví VNPT Pay hoặc Mobile Money để sử dụng được voucher theo quy định của thể lệ chương trình<br/><br/>Nếu tài khoản VNPT money <span class="semi-bold">đã kích hoạt</span> thực hiện tiếp theo Bước 4<br/>Nếu tài khoản VNPT Money <span class="semi-bold">chưa kích hoạt</span>, vui lòng xem hướng dẫn kích hoạt <a href="https://my.vnpt.com.vn/tinh-nang/tin-tuc?tab=0&id=4905">tại đây</a>`,
      `Thẻ voucher được tự động áp dụng cho giao dịch tại màn hình <span class="semi-bold">Xác nhận thanh toán</span><br/><br/>Nếu không muốn áp dụng voucher cho giao dịch hiện đang thực hiện thì bỏ chọn voucher đang áp dụng`,
      `Nhận mã OTP (nếu có) và thực hiện thanh toán`,
    ],
  };

  return (
    <>
      <div className="wrapper">
          <div className="background">
            <div className="right_decor">
              <img src={bag_decor_img} />
            </div>
          </div>
        <div className="contentwrapper">
          <div className="logo">
            <img src={vnpt_logo} />
          </div>
          <div className="content">
            <div className="title" style={{ marginTop: "24px" }}>
              Dùng MyVNPT thật đã <br/>Nhận ngay Siêu voucher 50%
            </div>
            <div className="contentCTKM" style={{ marginTop: "24px" }}>
              Nạp tiền điện thoại VinaPhone và thanh toán hóa đơn VNPT vô cùng
              đơn giản, nhận ngay ưu đãi 50% (tối đa 50.000đ). Duy nhất trên ứng
              dụng MyVNPT.
            </div>
            <div className="banner" style={{ marginTop: "32px" }}>
              <img src={lazada} />
            </div>
            <div className="subtitle" style={{ marginTop: "12px" }}>
              Tưng bừng năm mới, MyVNPT mời bạn deal hot 50%!
            </div>
            <div className="contentCTKM" style={{ marginTop: "24px" }}>
              Tận hưởng ưu đãi siêu hấp dẫn từ ngày 10/01 - 29/02/2024! Dành
              riêng cho khách hàng MyVNPT!
              <br />
              <br />
              Thao tác đơn giản! Thanh toán thành công một trong các dịch vụ
              trên ứng dụng MyVNPT thông qua nguồn tiền Thẻ ngân hàng nội địa/
              ngân hàng quốc tế hoặc Ví VNPT Pay hoặc Mobile Money trong tháng:
              <br />
              🔹 Nạp điện thoại VinaPhone
              <br />
              🔹 Mua mã thẻ Vinaphone
              <br />
              🔹 Đóng cước viễn thông
              <br />
              🔹 Thanh toán đơn hàng
              <br />
              🔹 Đóng trước cước
              <br />
              <br />
              👉 Nhận ngay 01 VOUCHER 50% giá trị thanh toán của giao dịch đó,
              tối đa 50.000đ. <br />
              <br />
              ▶️ Mỗi khách hàng nhận được 01 lần ưu đãi/01 tháng
              <br />
              ▶️ Chi tiết thể lệ <a href="https://my.vnpt.com.vn/tinh-nang/tin-tuc?tab=0&id=4904">xem tại đây</a>
              <br />
            </div>
          </div>
          <div className="subtitle2" style={{ marginTop: "12px" }}>
            Hướng dẫn tham gia CTKM
          </div>
          {showGetVoucher === true && (
            <>
              <div className="tab_voucher_tutorial">
                <div
                  className="tab active"
                  onClick={() => setShowGetVoucher(true)}
                >
                  Thanh toán và nhận <br /> Voucher 50%
                </div>
                <div className="tab" onClick={() => setShowGetVoucher(false)}>
                  Sử dụng voucher
                </div>
              </div>
              <Carousel
                draggable={false}
                responsive={responsive}
                infinite={false}
                transitionDuration={0}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                ref={(el) => (refCarousel = el)}
                arrows={false}
                showDots={true}
                dotListClass="custom-dot-list-style"
              >
                {getVoucher.title.map((item, index) => (
                  <>
                    <div className="image">
                      <img src={getVoucher.image[index]} alt="" />
                    </div>
                    <div className="title2" style={{ marginTop: "40px" }}>
                      {item}
                    </div>
                    <div
                      className="content-carousel"
                      style={{ marginTop: "12px" }}
                      dangerouslySetInnerHTML={{
                        __html: getVoucher.content[index],
                      }}
                    />
                  </>
                ))}
              </Carousel>
            </>
          )}

          {showGetVoucher === false && (
            <>
              <div className="tab_voucher_tutorial">
                <div className="tab" onClick={() => setShowGetVoucher(true)}>
                  Thanh toán và nhận <br /> Voucher 50%
                </div>
                <div
                  className="tab active"
                  onClick={() => setShowGetVoucher(false)}
                >
                  Sử dụng voucher
                </div>
              </div>
              <Carousel
                draggable={false}
                responsive={responsive}
                infinite={false}
                transitionDuration={0}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                ref={(el) => (refCarousel = el)}
                arrows={false}
                showDots={true}
                dotListClass="custom-dot-list-style"
              >
                {useVoucher.title.map((item, index) => (
                  <>
                    <div className="image">
                      <img src={useVoucher.image[index]} alt="" />
                    </div>
                    <div className="title2" style={{ marginTop: "40px" }}>
                      {item}
                    </div>
                    <div
                      className="content-carousel"
                      style={{ marginTop: "12px" }}
                      dangerouslySetInnerHTML={{
                        __html: useVoucher.content[index],
                      }}
                    />
                  </>
                ))}
              </Carousel>
            </>
          )}
          <div
            className="buttons"
            style={{ marginTop: "86px"}}
          >
            <a className="primary_button" href="https://my.vnpt.com.vn/app?screenCode=TOPUP_MONEY">Nạp thẻ</a>
            <a className="secondary_button" href="https://my.vnpt.com.vn/app?screenCode=TELECOM_BILL">Thanh toán cước</a> {/* staging */}
            {/*<a className="primary_button" href="https://webmyvnpt.vnptvas.com/app?screencode=TOPUP_MONEY">Nạp thẻ</a>
            <a className="secondary_button" href="https://webmyvnpt.vnptvas.com/app?screencode=TELECOM_BILL">Thanh toán cước</a>{/* prod */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CTKMj2k;
